import { render, staticRenderFns } from "./OfertaDemandaDetalle.vue?vue&type=template&id=3a09ca9d&scoped=true"
import script from "./OfertaDemandaDetalle.vue?vue&type=script&lang=ts"
export * from "./OfertaDemandaDetalle.vue?vue&type=script&lang=ts"
import style0 from "./OfertaDemandaDetalle.vue?vue&type=style&index=0&id=3a09ca9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a09ca9d",
  null
  
)

export default component.exports